import { useMemo } from "react";
import { CircularUploadFile } from "@/components/upload";
import { useUserStore } from "@/store/userStore";
import { toastWarning } from "@/utils/toastify";
import AvatarDefault from "/src/assets/AvatarDefault.svg";
import { useAuth } from "@/contexts/AuthContext";
import { PriorityRole, RoleEnum } from "@/types";

const UpdateAvatar = () => {
  const { changeAvatar, currentUserInfor } = useUserStore();
  const { role, user, updateUser } = useAuth();

  const isMyProfile = useMemo(() => {
    return currentUserInfor?.email === user?.email;
  }, [currentUserInfor?.email, user?.email]);

  const handleUpdateAvatar = async (file: File | null) => {
    const resp = await changeAvatar(Number(currentUserInfor?.id), {
      file: file,
    });
    if (isMyProfile) {
      updateUser({ ...(user || {}), image: resp } as any);
    }
  };

  const hasUpdatePermission = useMemo(() => {
    return (
      PriorityRole[role || RoleEnum.OTHER] >
        PriorityRole[currentUserInfor?.role.name || RoleEnum.OTHER] ||
      role === RoleEnum.COMPANY_ADMIN
    );
  }, [role, currentUserInfor?.role.name]);

  return (
    <div
      className="flex flex-col justify-center items-center gap-4 py-20 px-4 self-stretch rounded-2xl bg-white h-full relative"
      style={{
        boxShadow:
          "0 0 2px 0 rgba(145, 158, 171, 0.20), 0 12px 24px -4px rgba(145, 158, 171, 0.12)",
      }}
    >
      <div className="px-[20.5px]">
        <CircularUploadFile
          disabled={!isMyProfile && !hasUpdatePermission}
          {...{
            value: currentUserInfor?.image || AvatarDefault,
            onChange: (file) => {
              handleUpdateAvatar(file);
            },
            onErrorLargeFile: () => {
              toastWarning("アップロードファイルは10MB以内にしてください。");
            },
            onErrorFileType: () => {
              toastWarning(
                "JPEG（.jpg/.jpeg）、PNG、GIF形式のファイルをアップロードしてください。"
              );
            },
            fileSize: 10,
            acceptFile: "image/jpeg, image/jpg, image/png, image/gif",
          }}
        />
      </div>
    </div>
  );
};

export { UpdateAvatar };
